import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../Announcement/Announcement.css";

const API_URL = "https://aadyaacademy.org/api/announcements";

function Announcement() {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize navigate function

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const response = await axios.get(API_URL);
        const allAnnouncements = response.data;

        const now = new Date();
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(now.getDate() - 7);

        const recentAnnouncements = allAnnouncements.filter((announcement) => {
          const annDate = new Date(announcement.date);
          return annDate >= sevenDaysAgo && annDate <= now;
        });

        setAnnouncements(recentAnnouncements);
      } catch (error) {
        console.error("Error fetching announcements:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="announcements-header">
        <h1>Announcements</h1>
        <div className="annonce-add-btn">
          {/* Navigate to AnnouncementPage when clicking the button */}
          <button onClick={() => navigate("/AnnouncementPage")}>+</button>
        </div>
      </div>
      <div className="announcements-div">
        {announcements.length === 0 ? (
          <div>No announcements found</div>
        ) : (
          announcements.map((announcement) => (
            <div className="announce-div" key={announcement.id}>
              <div className={`announcement-icon ${announcement.icon_color}`}>
                {announcement.icon}
              </div>
              <div className="content-a">
                <h4>{announcement.title}</h4>
                <p>{announcement.description}</p>
              </div>
              <div className="time">
                <div className="time-div-bottom">{announcement.date}</div>
                <div className="time-div-bottom">{announcement.time}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}

export default Announcement;
